import { take, put } from "redux-saga/effects";
import { GET_AUTHOR_LIST, getAuthorListActions } from "src/redux/actions/book";

// services
import { getTagList } from "src/services/http/book";

// types
import { GetTagListRequestTypes, GetTagListResponseTypes } from "../../actions/book/types";

import * as Effects from "redux-saga/effects";

const call: any = Effects.call;

function* watchGetAuthorListRequest() {
  while (true) {
    const { payload }: IActionType<GetTagListRequestTypes> = yield take(GET_AUTHOR_LIST.REQUEST);

    try {
      const result: GetTagListResponseTypes = yield call(getTagList, payload);
      yield put(getAuthorListActions.success(result));
    } catch (e) {
      console.log(e, "error");
      yield put(getAuthorListActions.error(e as any));
    }
  }
}

export default watchGetAuthorListRequest;
